function addStuckAttributeWhenSticked() {
	let elements = document.getElementsByClassName("sticky");
	// console.log('elements', elements);
	const observer = new IntersectionObserver( 
	  ([e]) => e.target.toggleAttribute('stuck', e.intersectionRatio < 1),
	  { threshold: [1] }
	);

	Array.from(elements).forEach(element => {
		observer.observe(element);
	});
};
addStuckAttributeWhenSticked();